<template>
  <div class="flex items-start gap-12">
    <Avatar :name="senderName" :image-url="senderAvatarUrl" size="base" class="mt-4" />
    <div class="max-w-[75%] flex flex-col items-start relative message-bubble-container">
      <p class="text-s text-grey-text-subdued mb-4">{{ senderName }}</p>
      <div class="flex items-start gap-8">
        <Card :custom-classes="bubbleClasses" :aria-label="ariaLabel">
          <MessageBubbleBody :body="body" />
        </Card>
        <MessageBubbleActions :message-body="body" :is-visible="showActions" />
      </div>
      <MessageBubbleTimestamp :timestamp="timestamp" />
    </div>
  </div>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import Avatar from '@/components/avatar/Avatar.vue';
import MessageBubbleBody from './MessageBubbleBody.vue';
import MessageBubbleTimestamp from './MessageBubbleTimestamp.vue';
import MessageBubbleActions from './MessageBubbleActions.vue';

const INCOMING_BUBBLE_CLASSES = 'bg-grey-background-contrast w-fit min-w-0 flex-shrink-0 px-12 py-10';

export default {
  name: 'MessageBubbleIncoming',
  components: {
    Card,
    Avatar,
    MessageBubbleBody,
    MessageBubbleTimestamp,
    MessageBubbleActions,
  },
  props: {
    body: {
      type: String,
      default: '',
    },
    senderName: {
      type: String,
      required: true,
    },
    senderAvatarUrl: {
      type: String,
      default: '',
    },
    timestamp: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    bubbleClasses(): string {
      return INCOMING_BUBBLE_CLASSES;
    },
  },
};
</script>

<style scoped>
.message-bubble-container :deep(.action-menu) {
  left: 0;
  right: auto;
}
</style>
